/* Six o - cart gift (1 free pair of socks) + free-shipping wording. v3 2026-08-16.
   Gift is its own EUR 0 product, so no discount can fail and cause add/remove loops.
   Hard stops: paid gift line -> removed once; customer removal -> respected; max 3 adds. */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 58434858320204;   // FREE GIFT - Padel socks (1 pair), EUR 0
  var OFFER_ID = 'sixo-gift-offer';
  var DECLINE_KEY = 'sixo_gift_declined';
  var MAX_ADDS = 3;

  var busy = false;          // a cart write is in flight
  var adds = 0;              // add attempts this page load
  var weChanged = false;     // last cart change came from this script
  var prevHadGift = null;    // gift presence on the previous tick
  var lastCart = null;

  /* ---------- helpers ------------------------------------------------------ */

  function declined() {
    try { return !!sessionStorage.getItem(DECLINE_KEY); } catch (e) { return false; }
  }

  function decline(reason) {
    try { sessionStorage.setItem(DECLINE_KEY, reason); } catch (e) { /* private mode */ }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFT_VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  function hasRealItems(cart) {
    return cart.items.some(function (i) { return i.variant_id !== GIFT_VARIANT_ID; });
  }

  function changeQty(qty) {
    weChanged = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: String(GIFT_VARIANT_ID), quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function addGift() {
    weChanged = true;
    adds++;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(getCart);
  }

  /* ---------- 1. free shipping wording ------------------------------------ */
  /* Shipping is free on every order, so Kaching's "Add EUR X to unlock Free
     Shipping!" progress bar promised something the customer already has. */

  function fixShippingWording() {
    var bars = document.querySelectorAll('.kaching-cart__tiered-promotions-bar');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var text = bar.querySelector('.kaching-cart__tiered-promotions-bar-text');
      var prog = bar.querySelector('.kaching-cart__tiered-promotions-bar-progress-container');
      var fill = bar.querySelector('.kaching-cart__tiered-promotions-bar-progress-fill');
      if (prog) prog.style.display = 'none';
      if (fill) fill.style.display = 'none';
      bar.style.paddingBottom = '0';
      if (text && text.getAttribute('data-sixo-ship') !== '1') {
        text.setAttribute('data-sixo-ship', '1');
        text.innerHTML =
          '<span style="display:block;text-align:center;font-weight:600;font-size:13px;' +
          'letter-spacing:.06em;text-transform:uppercase;color:#171717">FREE Shipping Worldwide</span>';
      }
    }
  }

  /* ---------- 2. the offer message ---------------------------------------- */

  function offerHTML(state) {
    var added = state === 'added';
    return '' +
      '<div id="' + OFFER_ID + '" data-state="' + state + '" style="margin:10px 0;padding:12px 14px;' +
      'border-radius:12px;border:1px solid ' + (added ? '#cdbf88' : '#e6dfce') + ';background:' +
      (added ? '#fff8dd' : '#faf6ec') + ';font-family:inherit;color:#171717;text-align:left">' +
        '<p style="margin:0 0 3px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;' +
        'color:#9a8850;font-weight:600">Free gift</p>' +
        '<p style="margin:0;font-weight:600;font-size:14px;line-height:1.4">' +
          '&#127873; Buy now and get 1 socks for FREE <span style="font-weight:500;opacity:.75">(limited offer)</span>' +
        '</p>' +
        (added
          ? '<p style="margin:4px 0 0;font-size:12.5px;line-height:1.4;color:#5c5648">' +
            '&#10003; Added to your cart &mdash; no code needed</p>'
          : '') +
      '</div>';
  }

  // Insert (or refresh) the box next to an anchor, without duplicating it.
  function ensure(anchor, position, html, state) {
    if (!anchor) return;
    var current = position === 'afterend' ? anchor.nextElementSibling : anchor.firstElementChild;
    if (current && current.id === OFFER_ID) {
      if (current.getAttribute('data-state') !== state) current.outerHTML = html;
      return;
    }
    anchor.insertAdjacentHTML(position, html);
  }

  function renderOffer(cart) {
    if (!cart) return;
    var state = giftLine(cart) ? 'added' : 'offer';

    if (!hasRealItems(cart)) {          // empty cart: no offer anywhere
      document.querySelectorAll('#' + OFFER_ID).forEach(function (n) { n.remove(); });
      return;
    }

    var html = offerHTML(state);

    // Kaching drawer
    var promo = document.querySelector('.kaching-cart__tiered-promotions-bar');
    if (promo) ensure(promo, 'afterend', html, state);
    else ensure(document.querySelector('.kaching-cart__contents'), 'afterbegin', html, state);

    // theme drawer + native /cart page
    ensure(document.querySelector('.cart-drawer__inner, .drawer--cart .drawer__inner'), 'afterbegin', html, state);
    ensure(document.querySelector('.cart-form, form[action="/cart"], form[action^="/cart?"]'), 'afterbegin', html, state);

    dedupe();
  }

  // One box per container, whatever the drawer does to the DOM.
  function dedupe() {
    var parents = [];
    document.querySelectorAll('#' + OFFER_ID).forEach(function (n) {
      if (parents.indexOf(n.parentElement) === -1) parents.push(n.parentElement);
      else n.remove();
    });
  }

  /* ---------- 3. keep the gift line correct ------------------------------- */

  function reconcile(cart, changedByUs) {
    var gift = giftLine(cart);
    var real = hasRealItems(cart);

    if (gift) {
      if (!real) {                              // gift alone in the cart
        busy = true;
        return changeQty(0).then(function (c) { busy = false; return c; });
      }
      if (gift.final_line_price > 0) {          // must never happen at EUR 0 - stop for good
        decline('price');
        busy = true;
        return changeQty(0).then(function (c) { busy = false; return c; });
      }
      if (gift.quantity > 1) {                  // one pair, not more
        busy = true;
        return changeQty(1).then(function (c) { busy = false; return c; });
      }
      return Promise.resolve(cart);
    }

    // The customer took the gift out themselves -> leave it out for this session.
    if (prevHadGift === true && real && !changedByUs) {
      decline('manual');
      return Promise.resolve(cart);
    }

    if (real && !declined() && adds < MAX_ADDS) {
      busy = true;
      return addGift().then(function (c) { busy = false; return c; })
                      .catch(function () { busy = false; return cart; });
    }

    return Promise.resolve(cart);
  }

  /* ---------- loop --------------------------------------------------------- */

  function tick() {
    if (busy) return;
    getCart().then(function (cart) {
      // prevHadGift stays as it was at the end of the previous tick - that is
      // what tells a customer removal apart from a cart that never had a gift.
      var changedByUs = weChanged;
      weChanged = false;

      return reconcile(cart, changedByUs).then(function (after) {
        var c = (after && after.items) ? after : cart;
        lastCart = c;
        prevHadGift = !!giftLine(c);
        renderOffer(c);
        fixShippingWording();
      });
    }).catch(function () { /* stay quiet in the storefront */ });
  }

  function boot() {
    fixShippingWording();
    tick();
    setInterval(tick, 2500);

    // Drawers re-render their markup; re-place the box without waiting for the tick.
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        fixShippingWording();
        renderOffer(lastCart);
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
